const CUSTOMER_ID_STORAGE_KEY = "customer_selected_id";
const DEFAULT_SORT_COLUMN_FETCH_CUSTOMERS = "companyName";


export {
  CUSTOMER_ID_STORAGE_KEY,
  DEFAULT_SORT_COLUMN_FETCH_CUSTOMERS,
}
